/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Save_PreferencesInputs */

const en_save_preferences = /** @type {(inputs: Save_PreferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save preferences`)
};

const es_save_preferences = /** @type {(inputs: Save_PreferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar preferencias`)
};

const fr_save_preferences = /** @type {(inputs: Save_PreferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer les préférences`)
};

/**
* | output |
* | --- |
* | "Save preferences" |
*
* @param {Save_PreferencesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const save_preferences = /** @type {((inputs?: Save_PreferencesInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Save_PreferencesInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_save_preferences(inputs)
	if (locale === "es") return es_save_preferences(inputs)
	return fr_save_preferences(inputs)
});